import EventNoteIcon from "@mui/icons-material/EventNote";
import React from "react";

const OnlineCourse = [
  [
    "Course",
    "/admin/course",
    <EventNoteIcon sx={{ fontSize: "2rem", ml: "0.3rem" }}></EventNoteIcon>,
  ],
];

export default OnlineCourse;
